<template>

  <b-container>


    <b-row class="text-center">
      <div class="col-6">

        <b-img class="align-content-lg-start" :src="require('../assets/medicine-pill-health.jpg')" width="300" alt=""/>

      </div>

      <div class="col-lg-6 text-lg-right">
        <h4 class="text-muted ">درگاه پرداخت اینترنتی</h4>

        <p class="font-weight-bold h3"> مهندسی شده برای رشد و فروش بیشتر</p>

        <p>

          درگاه پرداخت زرین‌پال، با اتصالِ همزمان به درگاه‌های متنوع و معتبر بانکی

          (PSPها)،کاربران را به سریع‌ترین و مطمئن‌ترین درگاه بانکی منتقل می‌کند و به واسطه‌ی قابلیت مسیردهی هوشمند،
          باعث افزایش درصد تراکنش‌های موفق می‌شود.


        </p>

        <hr>


        <b-btn variant="warning" class="m-3">
          <router-link class="text-decoration-none text-dark font-weight-bold" :to="{name:'Home'}">
            ساخت درگاه پرداخت
          </router-link>
        </b-btn>
        <b-btn variant="blue">
          <router-link class="text-decoration-none" :to="{name:'Home'}">
            بیش تر بدانید
            <b-icon icon="arrow-left-short" aria-hidden="true"></b-icon>
          </router-link>
        </b-btn>
      </div>

    </b-row>


  </b-container>


</template>

<script>
export default {
  name: "S5"
}
</script>

<style scoped>

.btn-blue {
  background-color: #f5ffff;
}

p {
  line-height: 30px !important;
}

.icon-blue {
  background-color: #f5ffff;
}
</style>